/**
 * Detects the portal-api NY state mismatch error from kit registration.
 * From HTTPKitRegistrationStateError in portal-api (kit_registration_exceptions).
 */
export const NY_MISMATCH_PORTAL_ERROR_CODE = 'KIT1001'

type PortalError = {
  portal_error_code?: unknown
  response?: {
    data?: {
      portal_error_code?: unknown
    }
  }
}

export const getPortalErrorCode = (error: unknown): string | undefined => {
  if (!error || typeof error !== 'object') return undefined

  const portalError = error as PortalError
  const responseCode = portalError.response?.data?.portal_error_code
  const directCode = portalError.portal_error_code

  if (typeof responseCode === 'string') return responseCode
  if (typeof directCode === 'string') return directCode
  return undefined
}

export const isNYMismatchError = (error: unknown, portalErrorCode?: string | null) => {
  return (portalErrorCode ?? getPortalErrorCode(error)) === NY_MISMATCH_PORTAL_ERROR_CODE
}
